import moment from 'moment' ;
let config = {
    limit : localStorage.getItem('openXiao') ? JSON.parse(localStorage.getItem('openXiao')).limit : 30, 
	skip: 0,
	pageArr : [30 ,50, 100, 200],
	appid: '83313906a831064659be78ddd6800797',
	url: window.location.host.indexOf('xiaoiron') == -1 ? 'http://open.wegui.cn/v1' : 'https://open.xiaoiron.com/v1',
	dateForm: function(data){
		return moment(data).format('YYYY-MM-DD HH:mm:ss');
	}
}
Array.prototype.unique3 = function(){
	var res = [];
	var json = {};
	for(var i = 0; i < this.length; i++){
		if(!json[this[i]]){
			res.push(this[i]);
			json[this[i]] = 1;
		}
	}
	return res;
}

export default config ;


// WEBPACK FOOTER //
// ./src/util/util.js